module.exports = __webpack_public_path__ + "static/media/not_found.fd94d098.svg";